import { Video, Calendar, Clock, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function LiveCalls() {
  return (
    <div className="p-6 md:p-8">
      {/* Header */}
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 rounded-xl bg-purple-500/20 flex items-center justify-center">
          <Video className="w-6 h-6 text-purple-400" />
        </div>
        <div>
          <h1 className="font-display text-2xl font-bold">Live Calls</h1>
          <p className="text-muted-foreground">Upcoming coaching sessions</p>
        </div>
      </div>

      {/* Empty State */}
      <div className="text-center py-16 glass-card max-w-lg mx-auto">
        <Video className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
        <h3 className="font-semibold text-foreground text-xl mb-2">No upcoming calls</h3>
        <p className="text-muted-foreground">Check back later for scheduled coaching sessions!</p>
      </div>
    </div>
  );
}